var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGemImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 9C8.57843 9 9.25 8.32843 9.25 7.5C9.25 6.67157 8.57843 6 7.75 6C6.92157 6 6.25 6.67157 6.25 7.5C6.25 8.32843 6.92157 9 7.75 9Z",
    stroke: "#14181F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 12C2.75 7.522 2.75 5.282 4.141 3.891C5.532 2.5 7.771 2.5 12.25 2.5C16.728 2.5 18.968 2.5 20.359 3.891C21.75 5.282 21.75 7.521 21.75 12C21.75 16.478 21.75 18.718 20.359 20.109C18.968 21.5 16.729 21.5 12.25 21.5C7.772 21.5 5.532 21.5 4.141 20.109C2.75 18.718 2.75 16.479 2.75 12Z",
    stroke: "#14181F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 21C9.622 15.775 14.524 8.88403 21.748 13.542",
    stroke: "#14181F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemImage);
export default __webpack_public_path__ + "static/media/gem-image.78d1257692f525522f944d8f08e68ae4.svg";
export { ForwardRef as ReactComponent };